import { Box } from '@mui/material'
import { ArrowRight, BookAIcon, LucideIcon } from 'lucide-react'
import React from 'react'
import { useNavigate } from 'react-router-dom'
interface Props{
    icon?: LucideIcon,
    name:string,
    title:string,
    id:string
}
const SubjectCard = ({icon,name,title,id}:Props) => {
  const navigate = useNavigate();
  return (
    <Box className='w-full md:max-w-md lg:max-w-lg xl:max-w-xl rounded-lg p-4 sm:p-6 lg:p-8 bg-white shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 overflow-hidden flex flex-col justify-between min-h-[180px] sm:min-h-[200px] md:min-h-[220px] lg:min-h-[240px]'>
        <div className='p-2 sm:p-3 rounded-lg flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 bg-blue-300 text-blue-900'>
        {icon ? React.createElement(icon, { 
          className: 'w-5 h-5 sm:w-6 sm:h-6 md:w-7 md:h-7 lg:w-8 lg:h-8'
        }) : <BookAIcon className='w-5 h-5 sm:w-6 sm:h-6 md:w-7 md:h-7 lg:w-8 lg:h-8'/>}
        </div>
        <div className='mt-3 flex flex-col flex-grow'>
              <p className='text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold capitalize leading-tight'>{name}</p>
              <p className='text-xs sm:text-sm md:text-base pt-1.5 text-gray-600 leading-relaxed'>{title}</p>
        </div>
        <div className='mt-auto'>
          <button className='flex text-blue-800 gap-x-1 mt-4 items-center  text-xs sm:text-sm md:text-base hover:text-blue-900 transition-colors duration-200' onClick={()=>navigate(`/subjects/${id}`)}>
             <span> Explore Category</span> 
             <span><ArrowRight className='w-3 h-3 sm:w-4 sm:h-4'/></span>
          </button>
        </div>
    </Box>
  )
}

export default SubjectCard

export const SubjectCategryCard = ({icon,name,title,id}:Props)=>{
  const navigate = useNavigate();
  return (
    <Box className='rounded-md p-8 bg-white shadow-lg max-w-sm flex flex-col justify-between'>
        <div className='p-2 rounded-md flex items-center max-w-12 h-12 bg-blue-300 text-blue-900'>
             {icon ? React.createElement(icon, { size: 40 }) : <BookAIcon size={40}/>}
        </div>
        <div className='mt-3 flex flex-col'>
              <p className='text-2xl font-bold  capitalize'>{name}</p>
              <p className='text-sm pt-1.5'><span className='font-medium'>Mode : </span>{title}</p>
        </div>
        <div>
          <button className='flex text-blue-800 gap-x-1 mt-4' onClick={()=>navigate(`/subject-details/${id}`)}>
             <span> Explore Subjects</span> 
             <span><ArrowRight/></span>
          </button>
        </div>
    </Box>
  )
}
